(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["peakblades-abschluss"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-abschluss]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    /* Zeigerlicht wie im Auftakt. Braucht kein GSAP; bei reduzierter
       Bewegung steht es an seiner Vorgabestelle. */
    if (!still) {
      var raf = 0;
      root.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          var r = root.getBoundingClientRect();
          if (!r.width || !r.height) return;
          var x = ((ev.clientX - r.left) / r.width) * 100;
          var y = ((ev.clientY - r.top) / r.height) * 100;
          root.style.setProperty('--pb-mx', Math.max(-15, Math.min(115, x)) + '%');
          root.style.setProperty('--pb-my', Math.max(-15, Math.min(115, y)) + '%');
        });
      }, { passive: true });
    }

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveal, leicht gestaffelt: Marke, Ueberschrift, Text, Knopf.
       Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el, i) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55, delay: i * 0.08,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Produktstreifen: zieht beim Scrollen nach links, hoechstens um drei
       Viertel der Schirmbreite. Ausloeser ist der Streifen selbst, nicht der
       Abschnitt — sonst war er beim Erscheinen schon 430 px verschoben und die
       ersten Produkte nie zu sehen (gemessen 27.10. bei 1600 px). Begründung: die Kollektion zeigt sich, ohne
       dass jemand wischen muss; angeheftet wird nichts. Unter 768 px bleibt
       er wischbar und steht still. */
    var streifen = root.querySelector('.pb-streifen');
    var bahn = root.querySelector('[data-pb-streifen]');
    if (streifen && bahn) {
      gsap.matchMedia().add('(min-width: 768px)', function () {
        streifen.classList.add('pb-streifen--lauf');
        streifen.scrollLeft = 0;
        gsap.fromTo(bahn, { x: 0 }, {
          x: function () {
            var ueber = bahn.scrollWidth - streifen.clientWidth;
            return -Math.max(0, Math.min(ueber, window.innerWidth * 0.75));
          },
          ease: 'none',
          scrollTrigger: { trigger: streifen, start: 'top bottom', end: 'bottom top',
                           scrub: 0.6, invalidateOnRefresh: true }
        });
        gsap.from(bahn.children, {
          opacity: 0, y: 24, duration: 0.6, stagger: 0.05,
          scrollTrigger: { trigger: streifen, start: 'top 92%', once: true }
        });
        return function () { streifen.classList.remove('pb-streifen--lauf'); };
      });
    }

    /* Siegel: wandert langsamer als die Seite. Begründung: Tiefe, wie im
       Auftakt das Messer vor dem Grund. */
    var siegel = root.querySelector('[data-pb-siegel]');
    if (siegel) {
      gsap.fromTo(siegel, { yPercent: -10, rotation: -7 }, {
        yPercent: 10, rotation: -7, ease: 'none',
        scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }

    /* Hover-Physik auf dem Knopf. Begründung: Rückmeldung. Die Beschriftung
       folgt dem Zeiger ein Stück, damit der Knopf antwortet, bevor gedrückt
       wird. Bewusst klein (16 % in der Breite, 28 % in der Höhe). */
    gsap.utils.toArray(root.querySelectorAll('[data-pb-magnet]')).forEach(function (knopf) {
      var label = knopf.querySelector('.pb-btn-label');
      if (!label) return;
      var xZu = gsap.quickTo(label, 'x', { duration: 0.4, ease: 'power3' });
      var yZu = gsap.quickTo(label, 'y', { duration: 0.4, ease: 'power3' });
      knopf.addEventListener('mousemove', function (ev) {
        var r = knopf.getBoundingClientRect();
        xZu((ev.clientX - (r.left + r.width / 2)) * 0.16);
        yZu((ev.clientY - (r.top + r.height / 2)) * 0.28);
      });
      knopf.addEventListener('mouseleave', function () { xZu(0); yZu(0); });
    });

    /* Bilder und Schriften ändern die Höhe des Abschnitts. Danach die
       Trigger einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-aufbewahren"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-aufbewahren]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb der Reihe. Begründung: Erzählung. Die Staffelung
       zeigt, dass die drei Einträge eine Reihe sind und keine Sammlung von
       Einzelstücken. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: gruppe, start: 'top 80%', once: true }
      });
    });

    /* Bilder und Schriften ändern die Höhe des Abschnitts. Danach die
       Trigger einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-aufgaben"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-aufgaben]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb des Rasters. Begründung: Erzählung. Die Staffelung
       zeigt, dass die Spalten eine Reihe sind und keine Sammlung von
       Einzelstücken. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: gruppe, start: 'top 80%', once: true }
      });
    });

    /* Parallaxe auf dem Bildgrund. Begründung: Tiefe. Der Grund bewegt sich
       über den ganzen Abschnitt hinweg um zehn Prozent seiner Höhe, während
       der Text still steht. Symmetrisch um die Mitte, damit an keiner Kante
       ein Rand sichtbar wird. */
    var grund = root.querySelector('.pb-grund');
    if (grund) {
      gsap.fromTo(grund, { yPercent: -5 }, {
        yPercent: 5, ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    /* Bilder und Schriften ändern die Höhe des Abschnitts. Danach die
       Trigger einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-messer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-messer]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb einer Gruppe. Begründung: Erzählung. Beim
       waagerechten Lauf ist die Spur selbst nicht der Auslöser, weil ihre
       Lage beim Anheften springt; Auslöser ist der Abschnitt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      var ausloeser = gruppe.closest('.pb-bahn') ? root : gruppe;
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: ausloeser, start: 'top 80%', once: true }
      });
    });

    /* Waagerechter Lauf. Begründung: Ordnung. Nur ab 768 px; darunter
       bleibt die Spur eine von Hand wischbare Fläche. */
    var bahn = root.querySelector('.pb-bahn');
    var spur = root.querySelector('.pb-spur');
    /* Angeheftet wird die Buehne (Kopf + Lauf). Fehlt sie, bleibt die Bahn
       der Ausloeser — dann ist der Abschnitt wie vorher. */
    var buehne = root.querySelector('.pb-buehne') || bahn;
    if (bahn && spur) {
      var mm = gsap.matchMedia();
      mm.add('(min-width: 768px)', function () {
        var strecke = function () {
          return Math.max(0, spur.scrollWidth - bahn.clientWidth);
        };
        var lauf = gsap.to(spur, {
          x: function () { return -strecke(); },
          ease: 'none',
          scrollTrigger: {
            trigger: buehne,
            start: 'top top',
            end: function () {
              /* Nachlauf: die halbe Bildhoehe liess nach dem letzten Messer
                 eine grosse einfarbige Flaeche stehen (Owner 26.10.). Ein
                 Viertel reicht, damit die letzte Karte zur Ruhe kommt. */
              return '+=' + Math.round(strecke() + window.innerHeight * 0.25);
            },
            pin: true,
            scrub: 1,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        });
        return function () {
          if (lauf.scrollTrigger) lauf.scrollTrigger.kill();
          lauf.kill();
          gsap.set(spur, { clearProps: 'transform' });
        };
      });
    }

    /* Bilder und Schriften ändern die Breite der Spur. Danach die Trigger
       einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  /* Im Theme-Editor wird eine Section neu eingesetzt, ohne die Seite neu zu
     laden. Dann läuft das gebündelte Skript nicht erneut; dieser Zuhörer
     initialisiert den frisch eingesetzten Abschnitt. */
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-pflegen"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-pflegen]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb der beiden Schritte. Begründung: Erzählung. Die
       Staffelung zeigt die Reihenfolge: erst der Stein, dann das Leder. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: gruppe, start: 'top 80%', once: true }
      });
    });

    /* Parallaxe auf dem Bildgrund. Begründung: Tiefe. Der Grund bewegt sich
       über den ganzen Abschnitt hinweg um zehn Prozent seiner Höhe, während
       der Text still steht. Symmetrisch um die Mitte, damit an keiner Kante
       ein Rand sichtbar wird. */
    var grund = root.querySelector('.pb-grund');
    if (grund) {
      gsap.fromTo(grund, { yPercent: -5 }, {
        yPercent: 5, ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    /* Bilder und Schriften ändern die Höhe des Abschnitts. Danach die
       Trigger einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-schneiden"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-schneiden]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb des Gerüsts. Begründung: Erzählung. Die Staffelung
       zeigt, dass die Einträge eine Reihe sind und keine Sammlung von
       Einzelstücken. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: gruppe, start: 'top 80%', once: true }
      });
    });

    /* Parallaxe auf dem Bildgrund. Begründung: Tiefe. Der Grund bewegt sich
       über den ganzen Abschnitt hinweg um zehn Prozent seiner Höhe, während
       der Text still steht. Symmetrisch um die Mitte, damit an keiner Kante
       ein Rand sichtbar wird. */
    var grund = root.querySelector('.pb-grund');
    if (grund) {
      gsap.fromTo(grund, { yPercent: -5 }, {
        yPercent: 5, ease: 'none',
        scrollTrigger: {
          trigger: root,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    /* Bilder und Schriften ändern die Höhe des Abschnitts. Danach die
       Trigger einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peakblades-sortiment"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = '[data-pb-sortiment]';
  var GSAP_BASE = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function initSection(root) {
    if (root.getAttribute('data-pb-init') === '1') return;
    root.setAttribute('data-pb-init', '1');

    var still = !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var hatGsap = typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';

    if (still || !hatGsap) {
      document.documentElement.classList.remove('pb-js-motion');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: 'power2.out' });
    document.documentElement.classList.add('pb-motion-ready');

    /* Reveals des Abschnitts. Begründung: Lesetakt. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal]')).forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.55,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* Gestaffelt innerhalb des Stapels. Begründung: Erzählung. Die Staffelung
       zeigt, dass die drei Tafeln eine Reihenfolge sind und keine Auswahl
       nebeneinander. */
    gsap.utils.toArray(root.querySelectorAll('[data-reveal-group]')).forEach(function (gruppe) {
      gsap.to(gruppe.children, {
        opacity: 1, y: 0, duration: 0.5, stagger: 0.08,
        scrollTrigger: { trigger: gruppe, start: 'top 80%', once: true }
      });
    });

    /* Klebender Stapel der drei Achsen. Begründung: Erzählung. Die Tafel,
       die verlassen wird, geht leicht zurück und legt sich hinter einen
       Schleier, damit die neue Tafel vorne liegt und lesbar bleibt.
       Angeheftet wird nichts: position sticky macht die Arbeit, diese
       Animation kommt hinzu. Fällt GSAP aus, bleibt ein reiner Stapel. */
    var tafeln = root.querySelectorAll('.pb-achse');
    for (var i = 0; i < tafeln.length - 1; i++) {
      var naechste = tafeln[i + 1];
      var schleier = tafeln[i].querySelector('.pb-achse-schleier');
      gsap.to(tafeln[i], {
        scale: 0.95, ease: 'none',
        scrollTrigger: { trigger: naechste, start: 'top bottom', end: 'top top', scrub: true }
      });
      if (schleier) {
        gsap.fromTo(schleier, { opacity: 0 }, {
          opacity: 0.72, ease: 'none',
          scrollTrigger: { trigger: naechste, start: 'top bottom', end: 'top top', scrub: true }
        });
      }
    }

    /* Bilder und Schriften ändern die Höhe der Tafeln. Danach die Trigger
       einmal neu setzen, sonst sitzen die Startpunkte zu hoch. */
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function ensureGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }

    if (window.__pbGsapLoading) {
      document.addEventListener('pb:gsap-ready', cb, { once: true });
      return;
    }
    window.__pbGsapLoading = true;

    var s1 = document.createElement('script');
    s1.src = GSAP_BASE + 'gsap.min.js';
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = GSAP_BASE + 'ScrollTrigger.min.js';
      s2.onload = function () {
        window.__pbGsapLoading = false;
        document.dispatchEvent(new Event('pb:gsap-ready'));
        cb();
      };
      s2.onerror = function () {
        window.__pbGsapLoading = false;
        document.documentElement.classList.remove('pb-js-motion');
      };
      document.head.appendChild(s2);
    };
    s1.onerror = function () {
      window.__pbGsapLoading = false;
      document.documentElement.classList.remove('pb-js-motion');
    };
    document.head.appendChild(s1);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector(ROOT)) {
      ensureGsap(initAll);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ensureGsap(initAll); });
  } else {
    ensureGsap(initAll);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
